import { ReactComponent as OOSvg } from './icon_oo.svg';

const OOLogoComponent = () => {
  return <OOSvg style={{ height: '1rem' }} />;
};

export { OOLogoComponent as OOLogo };
